$(document).ready(function(){
$('.custom_carousel ul').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  touchThreshold: 500,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
          arrows: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        dots: true,
          arrows: false,
          dotsClass: 'slick-dots custom-dots'
      }
    },
    {
      breakpoint: 599,
      settings: {
         slidesToShow: 2,
          dots: true,
          arrows: false,
          dotsClass: 'slick-dots custom-dots'
      }
    }    
  ]
});
// hover on menu
        let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
      console.log(items)
      items.forEach(item => {
        item.addEventListener("mouseover", () => {
          item.setAttribute("open", true);
          item.querySelector("ul").addEventListener("mouseleave", () => {
            item.removeAttribute("open");
          });
        item.addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
      });

      });

      $(document).on('click', 'header-drawer[data-breakpoint="tablet"] nav.menu-drawer__navigation ul li .menu-drawer__menu-item.list-menu__item,header-drawer div#menu-drawer nav.menu-drawer__navigation ul.menu-drawer__menu.has-submenu.list-menu li .menu-drawer__menu-item_new', function() {    
        $(this).toggleClass("menu_activate");
      $(this).next().toggleClass("menu_open_active");
    });


      // collection filter
      
     $(document).on('click', '.shopify-custom_collection', function(e) {
            e.preventDefault();
            const url = $(this).attr('data-tag');
            const selectedSort = $('.facet-filters__sort').val() || 'manual';
            const targetUrl = new URL(url, window.location.origin);
            targetUrl.searchParams.set('sort_by', selectedSort);
            loadCollection(targetUrl.pathname + '?' + targetUrl.searchParams.toString());  
          });
         
          function loadCollection(url) {
            $('#product-grid').addClass('loading');
        
            $.get(url, function (response) {
              const $html = $('<div>').html(response);
             
              const $newGrid = $html.find('#custom_filter_id');
        
              if (!$newGrid.length || $newGrid.children().length === 0) {
                console.log('No products found.');
                  $('#product-grid').removeClass('loading');
                  return;
              }
        
              const images = $newGrid.find('img');
              let loaded = 0;
        
              if (images.length === 0) {
                updateGrid($newGrid.html(), url);
              } else {
                images.each(function () {
                  const img = new Image();
                  img.onload = img.onerror = function () {
                    loaded++;
                    if (loaded === images.length) {
                      updateGrid($newGrid.html(), url);
                    }
                  };
                  img.src = $(this).attr('src');
                });
              }
            });
          };
          function updateGrid(html, url) {
            $('#custom_filter_id').html(html).removeClass('loading');
            history.pushState(null, null, url);
        
            // Re-initialize any sliders or scripts
            if (typeof initializeSliders === 'function') {
              initializeSliders();
            }
            $(".my_top_bar").each(function() {
                var thandle = $(this).attr('handle');
              $(this).find('.sw-item').removeClass('active');
              var ptname = window.location.pathname;
                  if(ptname.indexOf(thandle) > -1)
                  {
                      $(this).find('.sw-item ').addClass('active');
                  }
            });    
          }

         

  // collection page active sub menu items
  $(document).on('click', '.collection_top_sub_coll ul li.shopify-custom_collection', function() {    
    $(".collection_top_sub_coll ul li.shopify-custom_collection").removeClass("active");
    $(this).addClass("active");    
  });

    // collectio page video play
        $(document).on('click', '.collec_main_video_sec', function(e) {
        $(this).children('.collec_main_video_sec_play_pause,.collec_main_video_thumbnail').toggleClass('hidden');
        var currentVideo = $(this).children('.collec_main_video_sec_main').find('video').get(0);
        if(currentVideo.paused){
            currentVideo.play();
        }
        else{
            currentVideo.pause();
        }
        
    });

      // on click filter sort_by
        $('.custom_desk_select_option .select select').change(function() {
          var selectedOption = $(this).val();
          $(this).parents('.custom_desk_select_option').parents('form').addClass('changed');
      });

      // product page kiwi size chart
      setTimeout(() => {
        if($('#size_guide_tab .ks-chart-container.sizing-chart-container').length){
            $('#size_guide_tab').parents('.product__accordion.accordion').removeClass('size_guide_tab_sec');
        }
      }, 1000);

      // product page main product on select color variant
        $(document).on('click', '.color_var_label', function(e) {
    var selectedColor = $(this).attr('colornamevalue');
    var mediaalt = $(".product media-gallery slider-component.slider-mobile-gutter ul.product__media-list li .product__media img");
    mediaalt.each(function(){
        var alt = $(this).attr('alt');
        if (!alt) return;
        e.preventDefault();          
        $('.product media-gallery slider-component.slider-mobile-gutter ul.product__media-list li').hide();
        $(`.product media-gallery slider-component.slider-mobile-gutter ul.product__media-list li:has(".product__media img[alt='${selectedColor}']")`).show();
    })
        
    });
      
            

})  // end document ready
